import { render, staticRenderFns } from "./MyBets.vue?vue&type=template&id=5359e06b&scoped=true"
import script from "./MyBets.vue?vue&type=script&lang=js"
export * from "./MyBets.vue?vue&type=script&lang=js"
import style0 from "./MyBets.vue?vue&type=style&index=0&id=5359e06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5359e06b",
  null
  
)

export default component.exports